import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { LegalTemplate } from "../src/landingPage/views/LegalPages/template/LegalTemplate";
import { withLegalHtml } from "../src/utils/server";

const TermsPage = ({ content }) => {
  return (
    <>
      <NextHead currentPath="/terms-and-conditions" title="Website Use Terms &amp; Conditions" />
      <LegalTemplate>{content}</LegalTemplate>
    </>
  );
};

export const getServerSideProps = withLegalHtml("terms_and_conditions", {
  wrapper: "MarketingWrapper",
});

export default TermsPage;
